import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './HeatmapFullScreenButton.scss';

export default function HeatmapFullScreenButton({ setFullScreenMode = () => {}, heatmapFullScreenModeIndicator }) {
  return (
    <ButtonWithIcon
      data-e2e="heatmap-full-screen"
      type="tertiary"
      size="small"
      linkIconSize="s"
      tabIndex="0"
      sprite={heatmapFullScreenModeIndicator ? 'Contract' : 'Expand'}
      onClick={() => {
        setFullScreenMode(!heatmapFullScreenModeIndicator);
      }}
      className="e2e-heatmap-full-screen"
      aria-label={heatmapFullScreenModeIndicator ? 'Exit full screen mode' : 'Enter full screen mode'}>
      {heatmapFullScreenModeIndicator ? 'Exit Full Screen' : 'Full Screen'}
    </ButtonWithIcon>
  );
}

HeatmapFullScreenButton.propTypes = {
  setFullScreenMode: PropTypes.func,
  heatmapFullScreenModeIndicator: PropTypes.bool.isRequired,
};
